/**
 * Runtime configuration. Deployed, serve.mjs injects window.__PAIRING_CONFIG__ from environment variables, so moving
 * from local to cloud is configuration only (ADR section 8, cutover rule). In development Vite supplies VITE_* values
 * from the root .env, and the API is proxied on the portal's own origin.
 */
export interface PortalConfig {
  /** API base URL; empty means the portal's own origin (the Vite proxy in development). */
  apiUrl: string;
  /** Supabase Auth, as the browser reaches it. Used for sign-in only, never for data. */
  supabaseUrl: string;
  supabaseAnonKey: string;
  /** The client page's demo video URL (PAIRING_DEMO_VIDEO_URL). Empty: the build's value, or no video section. */
  demoVideoUrl: string;
  /** Error tracking (SENTRY_DSN_PORTAL on the portal). Empty: off. */
  sentryDsn: string;
  sentryEnvironment: string;
}

declare global {
  interface Window {
    __PAIRING_CONFIG__?: Partial<PortalConfig>;
  }
}

const injected = typeof window !== 'undefined' ? (window.__PAIRING_CONFIG__ ?? {}) : {};

export const config: PortalConfig = {
  apiUrl: (injected.apiUrl ?? import.meta.env.VITE_PAIRING_API_URL ?? import.meta.env.VITE_PLUMB_API_URL ?? '').replace(/\/$/, ''),
  supabaseUrl: (injected.supabaseUrl ?? import.meta.env.VITE_SUPABASE_URL ?? 'http://127.0.0.1:57321').replace(/\/$/, ''),
  supabaseAnonKey: injected.supabaseAnonKey ?? import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  demoVideoUrl: injected.demoVideoUrl ?? '',
  sentryDsn: injected.sentryDsn ?? '',
  sentryEnvironment: injected.sentryEnvironment ?? '',
};
